import {Alert, Button, FormControlLabel, Switch, Typography} from "@mui/material";
import React, {useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {useHwAPI} from "../HardwareGeneric";
import {EditHardwareItem} from "../HwEditingContextProvider";

export function ConfigureElectricStrike(props: {
    value: EditHardwareItem
    isRemoveESConfig: boolean;
    onUpdate(): void;
}) {
    const [active, setActive] = useState(props.value.electricStrikeConfig.activeLeaf || false);
    const [inactive, setInactive] = useState(props.value.electricStrikeConfig.inactiveLeaf || false);

    const hapi = useHwAPI();

    const update = useAsyncAction(async (input) => {
        await hapi.upsertItemSecondary(input);
    }, [])

    return (
        <div>
            <div style={{
                padding: 16
            }}>
                <Typography variant="body1">
                    Which frame-leaf has the electric strike?
                </Typography>

                {props.isRemoveESConfig && <Alert severity="error">
                    Active/In-Active should both be disabled
                </Alert>}

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 8
                }}>
                    <FormControlLabel onClick={() => setActive(!active)} control={<Switch checked={active} />} label="Active" />
                    <FormControlLabel onClick={() => setInactive(!inactive)} control={<Switch checked={inactive} />} label="In-Active" />
                </div>
                {update.LoadingElement}
                <div style={{marginTop: 8}}>
                    <Button variant="outlined" fullWidth onClick={() => update.callback(Object.assign({}, props.value, {
                        electricStrikeConfig: {
                            activeLeaf: active,
                            inactiveLeaf: inactive
                        }
                    }))}>Update</Button>
                </div>
            </div>
        </div>
    )
}